<div class="fwc-container sae-branding">
    <div class="fwc-row" *ngIf="participantId">
        <div class="fwc-flex sae-logos" *ngIf="header">
            <img *ngIf="header.brandLogo && header.brandLogo !== ''" src="{{header.brandLogo}}" [alt]="'Anthem'" />
            <div *ngIf="header.universityLogo && header.universityLogo !== ''" class="logo-divider"></div>
            <img *ngIf="header.universityLogo && header.universityLogo !== ''" [src]="header.universityLogo" [alt]="header.universityLabel" />
        </div>
        <div class="logout-btn" *ngIf="!token || token === ''; else authenticated">
          <button *ngIf="menuDisplay && participantId" class="fwc-btn fwc-btn-primary" (click)="navigateTo(participantId + '/login')">Login</button>
        </div>
      <ng-template #authenticated>
        <div class="nav-links" *ngIf="menuDisplay">
          <button *ngIf="participantId && !micrositeId" class="nav-link" (click)="navigateTo(participantId + '/secure/home')">Dashboard</button>
          <button *ngIf="participantId && micrositeId" class="nav-link" (click)="navigateTo('school/'+ micrositeId + '/secure/dashboard')">Dashboard</button>
          <button *ngIf="participantId" class="nav-link" (click)="navigateTo(participantId + '/secure/account')">My Account</button>
          <button class="nav-link" (click)="logout()">Log Out</button>
        </div>
      </ng-template>
      <div class="nav-links-mobile">
        <img (click)="openModalSlider()" class="hamburger-menu" src="assets/images/iconography-system-menu-hamburger.png">
      </div>
    </div>
    <div class="fwc-row" *ngIf="storyId">
      <div class="fwc-flex sae-logos" *ngIf="header">
        <img *ngIf="header.brandLogo && header.brandLogo !== ''" src="{{header.brandLogo}}"
          [alt]="'Anthem'" />
        <div *ngIf="header.universityLogo && header.universityLogo !== ''" class="logo-divider"></div>
        <img *ngIf="header.universityLogo && header.universityLogo !== ''" [src]="header.universityLogo"
          [alt]="header.universityLabel" />
      </div>
      <div class="logout-btn" *ngIf="!token || token === ''; else authenticated">
        <button *ngIf="menuDisplay && storyId" class="fwc-btn fwc-btn-primary"
          (click)="navigateTo('school/'+ storyId + '/login')">Login</button>
      </div>
      <ng-template #authenticated>
        <div class="nav-links" *ngIf="menuDisplay">
          <button *ngIf="storyId" class="nav-link" (click)="navigateTo('school/'+ storyId + '/secure/dashboard')">Dashboard</button>
          <button *ngIf="storyId" class="nav-link" (click)="navigateTo('school/'+ storyId + '/secure/account')">My Account</button>
          <button class="nav-link" (click)="logout()">Log Out</button>
        </div>
      </ng-template>
      <div class="nav-links-mobile">
        <img (click)="openModalSlider()" class="hamburger-menu" src="assets/images/iconography-system-menu-hamburger.png">
      </div>
    </div>
</div>

<fwc-modal-slide [id]="'fwcMobileHeadSlider'" direction="right" lock-scroll="true" caller-id="openSlideModal" label-aria-modal-header="Slide In Modal Header" (fwc-modal-close)="closeModalSlider($event)"></fwc-modal-slide>

<template id="modalSlideContent1">
  <div id="template-holder-mobileHead">
  <div class="slide-modal-content" id="mobile-header-slider">
    <div class="mobile-nav-links">
      <ng-container *ngIf="!token || token === ''; else authenticatedMenu">
        <button *ngIf="menuDisplay && participantId" class="fwc-btn fwc-btn-primary" (click)="navigateTo(participantId + '/login');closeModalSlider($event)">Login</button>
        <button *ngIf="menuDisplay && storyId" class="fwc-btn fwc-btn-primary" (click)="navigateTo('school/'+ storyId + '/login');closeModalSlider($event)">Login</button>
      </ng-container>
      <ng-template #authenticatedMenu>
        <a *ngIf="menuDisplay && participantId && !micrositeId" class="nav-link" (click)="navigateTo(participantId + '/secure/home');closeModalSlider($event)">Dashboard</a>
        <a *ngIf="menuDisplay && participantId && micrositeId" class="nav-link" (click)="navigateTo('school/'+ micrositeId + '/secure/dashboard');closeModalSlider($event)">Dashboard</a>
        <a *ngIf="menuDisplay && participantId" class="nav-link" (click)="navigateTo(participantId + '/secure/account');closeModalSlider($event)">My Account</a>
        <a *ngIf="menuDisplay && storyId" class="nav-link" (click)="navigateTo('school/'+ storyId + '/secure/dashboard');closeModalSlider($event)">Dashboard</a>
        <a *ngIf="menuDisplay && storyId" class="nav-link" (click)="navigateTo('school/'+ storyId + '/secure/account');closeModalSlider($event)">My Account</a>
        <a *ngIf="menuDisplay" class="nav-link" (click)="logout();closeModalSlider($event)">Log Out</a>
      </ng-template>
    </div>
  </div>
  </div>
</template>
@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}

